/**
 * Auxiliary function to get the data test id string
 *
 * @param {string} id - the data test id to use
 *
 * @returns {string} the data test id format with the selected id
 */
export const getTestId = (id: string): string => `[data-testid="${id}"]`;
